import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8b9cxhr4de: FaireBrandEntity = {
  token: "b_8b9cxhr4de",
  type: "brand",
  name: "El Chilito Hot Sauce",
  avatarUrl:
    "https://cdn.faire.com/fastly/2cebea1c722459e0ffc1cf9a3704023338456695784ee6d036f516ad33e960ff.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c94ab51b5eb9fdbc87f04bf3624ae85fe931df3cc502ba40689cc872bf9f08af.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2cebea1c722459e0ffc1cf9a3704023338456695784ee6d036f516ad33e960ff.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c94ab51b5eb9fdbc87f04bf3624ae85fe931df3cc502ba40689cc872bf9f08af.png",
  location: "los angeles, CA, USA",
  minimumOrderDollars: 96,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "El Chilito Hot Sauce is a deeply flavorful, textured chile de arbol hot sauce inspired by a decades-old family recipe passed down through three generations. Hand-crafted with toasted sesame seeds, piloncillo, garlic, vinegar, oregano, and spices, it delivers bold heat with rich, savory depth. \n\nTry El Chilito Hot Sauce on... EVERYTHING! :) \n\nOur favorites are eggs, breakfast burritos, pizza, tacos, soup, burgers, dumplings or mix with your favorite ingredients to make your own secret sauce. \n\nIngredients: Made with LOVE, Distilled Vinegar, Pineapple Juice, Chili Pepper, Piloncillo, Garlic, Salt, Spices and Sesame Seed. ",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:25.446Z",
    importedBy: "entity-db-cli",
  },
};
